// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","White":"#FFFFFF","BreakpointFromMedium":"(min-width: 640px)","wrapper":"HeroMessage_wrapper__b59Cc"};